import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import api from "../../lib/api";
import { Newspaper, Eye, MessageSquare, Users2, FileText, Clock } from "lucide-react";

const Stat = ({ icon: Icon, label, value, testid }) => (
  <div className="border border-zinc-300 bg-white p-4" data-testid={testid}>
    <div className="flex items-center gap-2 overline">
      <Icon size={12}/> {label}
    </div>
    <p className="font-serif-display text-4xl font-bold mt-2">{value}</p>
  </div>
);

export default function AdminDashboard() {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/stats").then(r => setS(r.data)).catch(() => setS({}));
  }, []);

  return (
    <AdminLayout>
      <div data-testid="admin-dashboard">
        <h1 className="font-serif-display text-4xl font-bold">Dashboard</h1>
        <p className="font-sans-ui text-sm text-zinc-500 mt-1">Visão geral do portal</p>

        {!s ? (
          <p className="mt-8 font-sans-ui text-zinc-500">Carregando estatísticas...</p>
        ) : (
          <>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
              <Stat icon={Newspaper} label="Notícias publicadas" value={s.published || 0} testid="stat-published" />
              <Stat icon={FileText} label="Rascunhos" value={s.drafts || 0} testid="stat-drafts" />
              <Stat icon={Clock} label="Agendadas" value={s.scheduled || 0} testid="stat-scheduled" />
              <Stat icon={Eye} label="Visualizações totais" value={s.total_views || 0} testid="stat-views" />
              <Stat icon={MessageSquare} label="Comentários" value={s.total_comments || 0} testid="stat-comments" />
              <Stat icon={Users2} label="Autores" value={s.total_authors || 0} testid="stat-authors" />
              <Stat icon={Newspaper} label="Categorias" value={s.total_categories || 0} testid="stat-categories" />
              <Stat icon={Users2} label="Usuários" value={s.total_users || 0} testid="stat-users" />
            </div>

            <div className="mt-8 border border-zinc-300 bg-white p-6">
              <h2 className="overline">Notícias mais lidas</h2>
              <ul className="mt-3 divide-y divide-zinc-200">
                {(s.top_articles || []).map((a, i) => (
                  <li key={a.slug} className="py-3 flex justify-between items-center" data-testid={`top-article-${i}`}>
                    <Link to={`/noticia/${a.slug}`} className="font-serif-display text-lg font-semibold hover:underline">{a.title}</Link>
                    <span className="font-sans-ui text-sm text-zinc-500">{a.views || 0} views</span>
                  </li>
                ))}
                {(!s.top_articles || s.top_articles.length === 0) && <p className="font-sans-ui text-sm text-zinc-500 py-3">Sem dados ainda.</p>}
              </ul>
            </div>
          </>
        )}
      </div>
    </AdminLayout>
  );
}
